import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-691d215c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { SmartLock } from '@/models';
import {toRefs, ref, onMounted, inject, onBeforeUnmount} from 'vue'

interface Props {
  smartLock: SmartLock;
  expired: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    smartLock: null,
    expired: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  smartLock: SmartLock;
  expired: boolean;
}



const api: any = inject('api');

const { smartLock, expired } = toRefs(props);

const MAX_SLIDE_SIZE = 265;

const lock = ref();
const back = ref();

const enableControl = ref(false);
const touchStartX = ref(0);
const intervalHandler = ref();

const sending = ref(false);

const sendOpen = async() => {
  sending.value = true;
  try {
    await api.sendUnlockToDevice(smartLock.value.deviceCode, smartLock.value.serialNo);
  }
  catch(e) {
    console.log(e);
  }
  sending.value = false;
}

onMounted(() => {
  lock.value.addEventListener('touchstart', (e) => {
    if (sending.value || expired.value) {
      return;
    }
    var touchObject = e.changedTouches[0] ;
    touchStartX.value = touchObject.pageX;
    enableControl.value = true;
    back.value.style.display = 'none';
  });

  lock.value.addEventListener('touchmove', (e) => {
    if (!enableControl.value) {
      return;
    }
    e.preventDefault();
    var touchObject = e.changedTouches[0] ;
    let offset = touchObject.pageX - touchStartX.value;
    if (offset < 0) {
      offset = 0;
    }
    else if (offset > MAX_SLIDE_SIZE) {
      offset = MAX_SLIDE_SIZE;
      sendOpen();
      enableControl.value = false;
    }
    lock.value.style.left = offset + 'px';
    back.value.style.display = 'block';
  });
 
  lock.value.addEventListener('touchend', (e) => {
    enableControl.value = false;
    back.value.style.display = 'none';
  });

  intervalHandler.value = setInterval(() => {
    if (enableControl.value) {
      return;
    }
    let offset = lock.value.style ? lock.value.style.left.replace('px', '') - 10 : 0;
    if (offset <= 3) {
      offset = 3;
    } 
    lock.value.style.left = offset + 'px';
  }, 16);
})

onBeforeUnmount(() => {
  clearInterval(intervalHandler.value);
  clearTimeout(intervalHandler.value);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["btn-unlock", {'woman': _unref(smartLock).isFemale, 'common': !_unref(smartLock).isFemale, 'expired' : _unref(expired)}])
  }, [
    _createElementVNode("div", {
      ref_key: "lock",
      ref: lock
    }, [
      _createElementVNode("img", {
        src: require('@/assets/img/unlock.png')
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        ref_key: "back",
        ref: back
      }, null, 512)
    ], 512),
    _createElementVNode("div", null, _toDisplayString(_unref(smartLock).name), 1),
    (!_unref(expired))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "スライドして解錠"))
      : _createCommentVNode("", true),
    (_unref(expired))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "有効期限切れ"))
      : _createCommentVNode("", true)
  ], 2))
}
}

})